// extracted by mini-css-extract-plugin
export default {"root":"_SbO6q","buttonOnly":"ZTYKRB"};